import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import { useLanguage } from '../contexts/LanguageContext';

const PrivacyPolicy = () => {
  const { t, isRTL } = useLanguage();

  return (
    <div className="landing-container" dir={isRTL ? 'rtl' : 'ltr'}>
      <header className="landing-header">
        <h1>{t('privacyPolicy')}</h1>
        <p>{t('lastUpdated')} {new Date().toLocaleDateString()}</p>
      </header>

      <main className="landing-main" style={{ textAlign: isRTL ? 'right' : 'left', maxWidth: '800px', margin: '0 auto' }}>
        <section>
          <h2>{t('informationWeCollect')}</h2>
          <p>{t('informationWeCollectDescription')}</p>

          <h3>{t('accountInformation')}</h3>
          <p>{t('accountInformationDescription')}</p>

          <h3>{t('usageInformation')}</h3>
          <p>{t('usageInformationDescription')}</p>

          <h3>{t('technicalInformation')}</h3>
          <p>{t('technicalInformationDescription')}</p>
        </section>

        <section>
          <h2>Advertising and Google AdSense</h2>
          <p>
            We use Google AdSense to display advertisements. Google and its partners may use cookies and similar technologies to serve ads based on your visits to this and other sites.
          </p>
          <p>
            You can learn more about how Google uses data from partners at <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noreferrer">Google Ads Policies</a>, and manage your ad settings at <a href="https://adssettings.google.com" target="_blank" rel="noreferrer">Google Ad Settings</a>.
          </p>
          <h3>Personalized vs. Non‑personalized Ads</h3>
          <p>
            Where required (for example, in the EEA/UK), we request your consent for personalized advertising. If you do not consent, we will serve non‑personalized ads, which use contextual information instead of cookies for ad personalization.
          </p>
          <p>
            You can change your preference at any time using the consent banner or your browser settings. Non‑personalized ads may still use cookies for frequency capping, aggregated ad reporting, and to combat fraud/abuse.
          </p>
        </section>

        <section>
          <h2>{t('howWeUseYourInformation')}</h2>
          <p>{t('howWeUseDescription')}</p>
          <ul>
            <li>{t('provideAndImprove')}</li>
            <li>{t('personalizeExperience')}</li>
            <li>{t('generateAIContent')}</li>
            <li>{t('communicateWithYou')}</li>
            <li>{t('ensureSecurity')}</li>
          </ul>
        </section>

        <section>
          <h2>Cookies and Similar Technologies</h2>
          <p>
            We use cookies and local storage to provide core functionality (such as authentication), improve the app, and support advertising. You can control cookies through your browser settings. Disabling certain cookies may affect functionality.
          </p>
        </section>

        <section>
          <h2>{t('informationSharing')}</h2>
          <p>{t('informationSharingDescription')}</p>

          <h3>{t('serviceProviders')}</h3>
          <p>{t('serviceProvidersDescription')}</p>

          <h3>{t('legalRequirements')}</h3>
          <p>{t('legalRequirementsDescription')}</p>
        </section>

        <section>
          <h2>{t('dataSecurity')}</h2>
          <p>{t('dataSecurityDescription')}</p>
        </section>

        <section>
          <h2>{t('yourRights')}</h2>
          <p>{t('yourRightsDescription')}</p>
          <ul>
            <li>{t('accessAndUpdate')}</li>
            <li>{t('deleteAccountData')}</li>
            <li>{t('optOutCommunications')}</li>
            <li>{t('requestInformation')}</li>
          </ul>
        </section>

        <section>
          <h2>{t('contactUs')}</h2>
          <p>{t('contactUsDescription')}</p>
        </section>

        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <Link to="/home" className="btn btn-primary">{t('backToHome')}</Link>
        </div>
      </main>

      <footer className="landing-footer">
        <div className="footer-links">
          <Link to="/about">{t('about')}</Link>
          <Link to="/privacy">{t('privacyPolicy')}</Link>
          <Link to="/terms">{t('termsOfService')}</Link>
          <Link to="/support">{t('supportTitle') || 'Support'}</Link>
        </div>
        <p>&copy; {new Date().getFullYear()} SafaCards App. {t('allRightsReserved')}</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy; 